'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagEtAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-3.05176e-05 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 -6.94394e-06 20C-6.94394e-06 13.3333 0.000144993 6.66667 -3.05176e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-6.94394e-06 6.66667H28V0H-3.05176e-05L-6.94394e-06 6.66667Z",
          fill: "#20AA46"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-6.94394e-06 20H28V13.3333H-6.94394e-06V20Z",
          fill: "#E92F3B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-6.94394e-06 13.3333H28V6.66667H-6.94394e-06V13.3333Z",
          fill: "#FADF50"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 14.6667C16.5773 14.6667 18.6667 12.5773 18.6667 10C18.6667 7.42267 16.5773 5.33333 14 5.33333C11.4227 5.33333 9.33333 7.42267 9.33333 10C9.33333 12.5773 11.4227 14.6667 14 14.6667Z",
          fill: "#205CCA"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 10.4813L14.7253 10.9984L14.4577 10.1487L15.1736 9.61866L14.2829 9.61064L14 8.76595L13.7171 9.61064L12.8263 9.61866L13.5423 10.1487L13.2746 10.9984L14 10.4813ZM12.0407 12.6967L12.7636 10.4017L10.8298 8.96994L13.2359 8.94828L14 6.66667L14.7641 8.94828L17.1702 8.96994L15.2364 10.4017L15.9593 12.6967L14 11.3L12.0407 12.6967Z",
          fill: "#FFDB3D"
        }
      )
    ]
  }
);
const VpFlagEtAsset = forwardRef(FlagEtAsset);

export { VpFlagEtAsset as default };
